import { Base_URL } from "./apiBaseUrl";

export { Base_URL };

export const webServiceUrl = {
  login: `${Base_URL}/api/leads/v1/login`,
  superAdminLogin: `${Base_URL}/api/superadmin/v1/admin-login`,

  //   Nestfin Superadmin
  GET_ALL_CITIES: `${Base_URL}/api/master/v1/get-all-cities`,
  GET_ALL_ORGANIZATIONS: `${Base_URL}/api/orgregister/v1/view-all-organization`,
  TOGGLE_ORGANIZATION_STATUS: `${Base_URL}/api/orgregister/v1/toggle-org-status`,
  GET_REALTIME_INVENTORY: `${Base_URL}/api/org/v1/rooms-inventory-get-s2`,
  GET_TENANTS_ORGANIZATION: `${Base_URL}/api/tanant/v1/property-tanant-get-all`,
  // GET_TENANTS_DETAILS: `${Base_URL_TenantDet}/api/tanant/v1/property-tanant-profile-details`,
  GET_TENANTS_DETAILS: `${Base_URL}/api/tanant/v1/property-tanant-profile-details`,
  GET_TENANT_AGREEMENT_DETAILS: `${Base_URL}/api/tanant/v1/property-tanant-terms-details`,
  GET_BOOKINGS: `${Base_URL}/api/org/v1/property-view-bookings`,
  GET_EXPENSES: `${Base_URL}/api/expense/v1/view-expense`,

  GET_ALL_PROPERTIES: `${Base_URL}/api/org/v1/getall-org-property`,
  GET_PROPERY_ALLOTED_FOR: `${Base_URL}/api/org/v1/get-org-property-alloted-for`,
  // GET_PROPERTY_BY_ID: `${Base_URL}/api/org/v1/view-org-property`,
  GET_PROPERTY_BY_ID: `${Base_URL}/api/org/v1/view-org-property`,

  EDIT_PROPERY_ALLOTED_FOR: `${Base_URL}/api/org/v1/org-property-alloted-for`,
  ADD_PROPERTY_IMAGES: `${Base_URL}/api/org/v1/upload-property-images`,
  DELETE_PROPERTY_IMAGES: `${Base_URL}/api/org/v1/delete-property-images`,
  EDIT_PROPERTY: `${Base_URL}/api/org/v1/add-org-property`,
  TOGGLE_PROPERTY_STATUS: `${Base_URL}/api/org/v1/toggle-status-org-property`,

  GET_COMPLAINTS: `${Base_URL}/api/complaint/v1/get-complaint`,
  GET_COMPLAINTS_DETAIL: `${Base_URL}/api/complaint/v1/complaint-history`,
  GET_LEADS_LIST: `${Base_URL}/api/superadmin/v1/get-leads`,
  ASSIGN_LEAD: `${Base_URL}/api/superadmin/v1/mannually-assign-lead`,
  DEASSIGN_LEAD: `${Base_URL}/api/superadmin/v1/mannually-de-assign-lead`,
  GET_PROPERTY_LEADS: `${Base_URL}/api/superadmin/v1/view-property-leads`,
  UPLOAD_LEADS_EXCEL: `${Base_URL}`,

  GET_ACTIVITIES_REPORT: `${Base_URL}/api/superadmin/v1/get-activities`,
  // GET_EXPENSES: `${Base_URL}/api/expense/v1/view-expense`,
  GET_COLLECTIONS_REPORT: `${Base_URL}/api/collection/service-selector`,
  SEND_PAYMENT_LINK: `${Base_URL}/api/collection/service-selector`,
  DOWNLOAD_PAYMENT_PROOF: (billId) =>
    `${Base_URL}/api/collection/payment-proof/${encodeURIComponent(billId)}`,
  PAYMENT_CHECKOUT: (token) =>
    `${Base_URL}/api/payment/${encodeURIComponent(token)}`,
  PAYMENT_CREATE_ORDER: `${Base_URL}/api/payment/create-order`,
  PAYMENT_VERIFY: `${Base_URL}/api/payment/verify`,
  PAYMENT_INVOICE: (token) =>
    `${Base_URL}/api/payment/${encodeURIComponent(token)}/invoice`,
  GET_STAFF_TRANSACTIONS: `${Base_URL}/`,
  GET_BANK_TRANSACTIONS: `${Base_URL}/`,
  GET_BANKS: `${Base_URL}/`,

  GET_SUBSCRIPTIONS_PMS: `${Base_URL}/api/org/v1/leads-subscription-history`,
  GET_SUBSCRIPTIONS_ACTIVE: `${Base_URL}/api/org/v1/leads-active-subscription`,
  //  end Nestfin Superadmin
};

// =============================================================
